import { APP_INITIALIZER, DoBootstrap, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CareModule } from 'src/app/care/care.module';
import { InboxModule } from 'src/app/care/inbox/inbox.module';
import { PublicationsModule } from 'src/app/care/publications/publications.module';
import { PushboxModule } from 'src/app/care/pushbox/pushbox.module';
import { SearchModule } from 'src/app/care/search/search.module';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { TrackLoggerService } from 'src/app/core/track/track-logger.service';
import { MarketingModule } from 'src/app/marketing/marketing.module';
import { MetricsModule } from 'src/app/metrics/metrics.module';
import { SitesService } from 'src/app/mobile/shared/sites.service';
import { UserModule } from 'src/app/mobile/shared/user/user.module';
import { ParametersModule } from 'src/app/parameters/parameters.module';
import { commonImports, commonProviders, initCtxAndTranslationService } from 'src/app/root-module-init';
import { SatisfactionSurveysModule } from 'src/app/shared/components/satisfaction-surveys/satisfaction-surveys.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TaskProcessPageModule } from 'src/app/task-process/task-process.module';
import { UserPreferencesModule } from 'src/app/user-preferences/user-preferences.module';

@NgModule({
  imports: [
    ...commonImports,
    RouterModule.forRoot([], { relativeLinkResolution: 'legacy' }), // import it so that the injector can inject it in the TaskProcessPage
    IonicModule.forRoot({
      mode: 'md',
    }),
    CareModule,
    InboxModule,
    MarketingModule,
    MetricsModule,
    ParametersModule,
    PublicationsModule,
    PushboxModule,
    SatisfactionSurveysModule,
    SearchModule,
    SharedModule,
    TaskProcessPageModule,
    UserModule,
    UserPreferencesModule,
  ],
  providers: [
    ...commonProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: initCtxAndTranslationService,
      multi: true,
      deps: [AlcmeonContextService, TranslateService, TrackLoggerService],
    },
    SitesService,
  ],
  bootstrap: [],
})
export class AdminFrontModule implements DoBootstrap {
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  ngDoBootstrap(): void {}
}
